import React from "react";

export const IconCreditCards = ({ handleClick = false }) => (
  <svg
    width="107"
    height="20"
    viewBox="0 0 107 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={() => (handleClick ? handleClick() : null)}
  >
    <path
      d="M14.3113 4.21191L9.59809 15.8183H6.52311L4.20375 6.55586C4.06294 5.98536 3.9405 5.77635 3.51225 5.536C2.81307 5.1445 1.65845 4.77719 0.642578 4.54922L0.711578 4.21191H5.66136C6.2923 4.21191 6.85948 4.6454 7.00273 5.3953L8.22766 12.1113L11.255 4.21171H14.3113V4.21191ZM26.3596 12.0291C26.3719 8.96581 22.2556 8.79706 22.2839 7.42865C22.2927 7.01219 22.6769 6.56941 23.5178 6.45639C23.9346 6.40008 25.0831 6.35712 26.3856 6.97581L26.8966 4.51458C26.1966 4.25235 25.2961 4 24.1756 4C21.3003 4 19.2768 5.5776 19.2597 7.8366C19.2412 9.50748 20.704 10.4399 21.8062 10.9951C22.94 11.5637 23.3204 11.929 23.3161 12.4376C23.308 13.2162 22.4118 13.5599 21.5742 13.5734C20.1121 13.5966 19.2637 13.1651 18.5874 12.8405L18.0601 15.3832C18.7398 15.7051 19.9944 15.9859 21.295 16C24.3511 16 26.3502 14.4419 26.3596 12.0291ZM33.9522 15.8185H36.6426L34.2942 4.21191H31.8109C31.2525 4.21191 30.7815 4.54748 30.573 5.06341L26.2079 15.8183H29.2624L29.8688 14.0847H33.601L33.9522 15.8183V15.8185ZM30.7064 11.7061L32.2375 7.34834L33.1187 11.7061H30.7064ZM18.4675 4.21191L16.0621 15.8183H13.1533L15.5596 4.21191H18.4675Z"
      fill="#163FA3"
    />
    <path
      d="M65.1585 3.71875H58.1284V16.2979H65.1585V3.71875Z"
      fill="#FF5F00"
    />
    <path
      d="M58.5733 10C58.5722 8.78853 58.8479 7.59269 59.3796 6.50301C59.9112 5.41332 60.6849 4.45836 61.642 3.7104C60.4568 2.78277 59.0333 2.20588 57.5344 2.04569C56.0354 1.8855 54.5215 2.14845 53.1655 2.80451C51.8096 3.46056 50.6664 4.48325 49.8665 5.75567C49.0667 7.02809 48.6426 8.4989 48.6426 10C48.6426 11.5011 49.0667 12.9719 49.8665 14.2443C50.6664 15.5167 51.8096 16.5394 53.1655 17.1955C54.5215 17.8516 56.0354 18.1145 57.5344 17.9543C59.0333 17.7941 60.4568 17.2172 61.642 16.2896C60.6849 15.5416 59.9112 14.5867 59.3796 13.497C58.8479 12.4073 58.5722 11.2115 58.5733 10Z"
      fill="#EB001B"
    />
    <path
      d="M74.6426 10C74.6426 11.5011 74.2185 12.9719 73.4188 14.2443C72.619 15.5167 71.4758 16.5394 70.1199 17.1955C68.764 17.8515 67.25 18.1145 65.7511 17.9543C64.2522 17.7941 62.8288 17.2172 61.6436 16.2896C62.5998 15.5409 63.3729 14.5858 63.9044 13.4963C64.436 12.4067 64.7122 11.2113 64.7122 10C64.7122 8.78872 64.436 7.59326 63.9044 6.50374C63.3729 5.41423 62.5998 4.45911 61.6436 3.7104C62.8288 2.78276 64.2522 2.20588 65.7511 2.04569C67.25 1.8855 68.764 2.14846 70.1199 2.80452C71.4758 3.46059 72.619 4.48328 73.4188 5.7557C74.2185 7.02812 74.6426 8.49892 74.6426 10Z"
      fill="#F79E1B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M103.091 12.23L101.487 10.4578H94.7388V16.05H101.432L103.046 14.26L104.677 16.05H106.64V15.9711L104.073 13.2511L106.64 10.5022V10.4578H104.697L103.089 12.23H103.091ZM99.4808 16.0244V14.7456H96.2743V13.8867H99.4041V12.62H96.2743V11.7456H99.4808V10.4822L102.081 13.25L99.4808 16.0244Z"
      fill="#2F6EC8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M106.641 14.8256V11.66L105.167 13.2356L106.641 14.8256Z"
      fill="#2F6EC8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M86.6426 0V20H106.641V16.8467H104.288L103.037 15.4667L101.795 16.8522L93.8877 16.8356V10.4744H91.3245L94.4821 3.30778H97.5564L98.6364 5.76V3.30778H102.432L103.086 5.14444L103.743 3.30778H106.641V4.08556H104.339L103.101 7.52889L101.87 4.09444L99.4774 4.08667V9.62222L97.0298 4.08778H95.0643L92.5834 9.67556H94.2855L94.7532 8.55667H97.2898L97.7575 9.67556H100.983V5.83556L102.411 9.67333H103.763L105.162 5.84889V9.68667L106.643 9.67333V9.68111V0H86.6426ZM95.2777 7.30111L96.0221 5.52222L96.7653 7.30111H95.2777Z"
      fill="#2F6EC8"
    />
  </svg>
);

export default IconCreditCards;
